export default "__VITE_PUBLIC_ASSET__4a9ff39d__"